import { Button, Input } from "@ui";
import style from "./ChangingIP.module.scss";
import { IProxy } from "@interfaces/user/proxy";
import { useUpdateTimeChangeIpAddressMutation } from "@RTKQuery/user/purchases/purchases";
import { useEffect, useState } from "react";
import { useAppSelector } from "store/hooks";

export function ChangingIP({
    data
}: {
    data: IProxy
}) {
    const { activePaginationLimit, activePaginationPage, activeSearchParameter, activeTags } = useAppSelector(state => state.myProxiesUserPage)

    const [updateTimeChangeIpAddress, {isSuccess, isLoading, reset, error}] = useUpdateTimeChangeIpAddressMutation();

    const [inputValue, setInputValue] = useState<number>(0)

    useEffect(() => {
        let timer: NodeJS.Timeout;

        if (isSuccess) {
            setInputValue(0)
            timer = setTimeout(() => {
                reset();
            }, 2500)
        }

        return () => {
            clearTimeout(timer)
        }
    }, [isSuccess])

    return (
        <div className={style.container}>
            <p className="text-center text-[#1B1B1D] text-[16px] font-semibold leading-normal mb-[10px]">Час зміни ір-адреси</p>
            <p className="text-center text-[#1B1B1D] text-[13px] font-normal mb-[30px] max-sm:mb-[20px]">Ваш ір-адрес змінюється кожних: <span className="font-semibold">{data.change_ip_time} сек.</span></p>
            <Input
                value={String(inputValue)}
                onChange={(value) => {
                    setInputValue(Number(value.replace(/\D/g, "")))
                }}
                label="Введіть нове значення"
                customStyle={{
                    width: "!w-[300px] !max-w-[300px] !mx-auto !mb-[30px]"
                }}
            />
            <p className="text-center text-[#1B1B1D] text-[13px] font-normal mb-[8px]">*Обов’язково вказуйте час оновлення ір у секундах </p>
            <p className="text-center text-[#1B1B1D] text-[13px] font-bold mb-[40px] max-sm:mb-[20px]">Наприклад: 4 хв - 240 сек.</p>
            <Button
                tabIndex={-1}
                text={
                    isSuccess
                    ?"Успішно збережено"
                    :"Зберегти"
                }
                color="blue"
                customStyle={{
                    button: "!w-[180px] !h-[38px] ",
                    width: "!mx-auto"
                }}
                loading={isLoading}
                errors={[
                    (error && ((extractError) => {
                        return extractError(error)
                    }))
                ]}
                onClick={() => {
                    updateTimeChangeIpAddress({
                        purchase_id: data.id,
                        time: inputValue,
                        params: {
                            limit: activePaginationLimit,
                            page: activePaginationPage,
                            search: activeSearchParameter,
                            tag_ids: activeTags
                        },
                    });
                }}
                resetStatus={() => {
                    reset();
                }}
            />
        </div>
    )
}